import React from "react";
import { Button } from "@mui/material";
import toast from "react-hot-toast";
import { downloadFile } from "../../../utils/downloadHelper";

const BulkUploadToast = ({ t, response }) => {
  const failedRowsLink = response.failedRowsLink || response.data?.failedRowsLink;
  const validCount = response.validCount !== undefined ? response.validCount : (response.data?.validCount || 0);
  const invalidCount = response.invalidCount !== undefined ? response.invalidCount : (response.data?.invalidCount || 0);
  const duplicateCount = response.duplicateCount !== undefined ? response.duplicateCount : (response.data?.duplicateCount || 0);

  return (
    <div style={{ display: "flex", alignItems: "center", padding: "10px" }}>
      <span
        style={{
          color: "yellow",
          fontSize: "1.5rem",
          marginRight: "12px",
        }}
      >
        ⚠️
      </span>
      <div style={{ flex: 1 }}>
        <strong>Import completed with some errors.</strong>
        <div style={{ marginTop: "5px" }}>
          <div>Valid Count: {validCount}</div>
          <div>Invalid Count: {invalidCount}</div>
          <div>Duplicate Count: {duplicateCount}</div>
          {failedRowsLink && (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => downloadFile(failedRowsLink)}
              style={{ marginTop: "8px" }}
            >
              Download Failed Rows
            </Button>
          )}
        </div>
      </div>
      <span
        style={{
          marginLeft: "auto",
          cursor: "pointer",
          color: "red",
          fontWeight: "bold",
          fontSize: "1.5rem",
        }}
        onClick={() => toast.dismiss(t.id)}
      >
        &times;
      </span>
    </div>
  );
};

export default BulkUploadToast;
